import { TOAST_TYPE, ToastOptions, useToastStore } from '@/store/useToastStore';

export * from '@/store/useToastStore';

export const useToast = () => {
  const toastStore = useToastStore();

  const list = toastStore.toDisplay;
  const queue = toastStore.queue;

  const toast = (message: string, type: TOAST_TYPE, options?: ToastOptions) => toastStore.addToast({ message, type, options });
  const success = (message: string, options?: ToastOptions) => toast(message, TOAST_TYPE.SUCCESS, options);
  const info = (message: string, options?: ToastOptions) => toast(message, TOAST_TYPE.INFO, options);
  const warn = (message: string, options?: ToastOptions) => toast(message, TOAST_TYPE.WARNING, options);
  const error = (message: string, options?: ToastOptions) => toast(message, TOAST_TYPE.ERROR, options);

  return { toast, success, info, warn, error, list, queue };
};
